import { render, staticRenderFns } from "./WelcomeLayout.vue?vue&type=template&id=164400f6&scoped=true&"
import script from "./WelcomeLayout.vue?vue&type=script&lang=ts&"
export * from "./WelcomeLayout.vue?vue&type=script&lang=ts&"
import style0 from "./WelcomeLayout.vue?vue&type=style&index=0&id=164400f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164400f6",
  null
  
)

export default component.exports